import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { send } from "@utils/fetch";
import { cloneDeep } from "lodash";
import store from "@utils/redux/store";
import { visitorLifecycleStates } from "@utils/constants";

export const VISITOR_STATUS_INITIAL_STATE = {};

const visitorStatusSlice = createSlice({
  name: "visitorStatus",
  initialState: cloneDeep(VISITOR_STATUS_INITIAL_STATE),
  reducers: {
    updateVisitorStatus(state, action) {
      return Object.assign({}, action.payload);
    },
  },
});

/**
 * Fetches subscriptions by user id and updates the slice (subscriptions and determinations).
 * @param {*} user_id
 */
export const updateVisitorStatusState = createAsyncThunk(
  "visitorStatus/updateVisitorStatusState",
  async ({ user_id, is_new_user }, thunkAPI) => {
    console.log("Updating user visitor status");
    const { surveyAnswers } = store.getState();
    let visitorStatus = {};
    try {
      ({ visitorStatus } = await send(
        "POST",
        "/visitor/api/v1/getVisitorStatus/",
        {
          clientUserId: user_id,
          surveyAnswers,
        }
      ));
    } catch (e) {
      console.log("Failed to retrieve visitor status");
      return;
    }

    // Override backend result if the user was freshly created
    if (is_new_user) {
      // NOTE(Kevin): This code should only be reachable if the user is in an email route
      visitorStatus.visitorState = visitorLifecycleStates.newVisitor;
    }

    thunkAPI.dispatch(
      updateVisitorStatus({
        ...visitorStatus,
      })
    );
  }
);

export const { updateVisitorStatus } = visitorStatusSlice.actions;

export default visitorStatusSlice.reducer;
